import { GiftcardHomePage, GiftcardShowPage, HomePageContextProvider } from 'components';
import { ProtectedRoute } from 'router';

export const giftcardRoutes = {
  giftcardHomePage: {
    path: '/cartes-cadeaux',
    component: () => (
      <ProtectedRoute>
        <HomePageContextProvider>
          <GiftcardHomePage />
        </HomePageContextProvider>
      </ProtectedRoute>
    )
  },
  giftcardShow: {
    path: '/cartes-cadeaux/:id',
    component: () => (
      <ProtectedRoute>
        <GiftcardShowPage />
      </ProtectedRoute>
    )
  }
};
